import { OptimizationMode } from '../../../../../types/Survey/Analysis/Concept'
import { ResultProps } from '../../../../../types/Survey/Analysis/FactorValues'
import { round, roundDown, roundUp } from '../../../../../utility'

const getQMAndDeskValues = (theoreticalQM: number, singleQM: number, optimizationMode: OptimizationMode, arbeitsplatzAmount: number): ResultProps => {
  const theroeticalSpaceAmount = theoreticalQM / singleQM
  let practicalSpaceAmount = theroeticalSpaceAmount

  if (optimizationMode === OptimizationMode.MIN) {
    const rest = theroeticalSpaceAmount % 1
    practicalSpaceAmount = rest < 0.8 ? roundDown(theroeticalSpaceAmount) : roundUp(theroeticalSpaceAmount)
  } else if (optimizationMode === OptimizationMode.MAX) {
    const rest = theroeticalSpaceAmount % 1
    practicalSpaceAmount = rest > 0.2 ? roundUp(theroeticalSpaceAmount) : roundDown(theroeticalSpaceAmount)
  } else if (optimizationMode === OptimizationMode.STANDARD) {
    const rest = theroeticalSpaceAmount % 1
    practicalSpaceAmount = rest >= 0.5 ? roundUp(theroeticalSpaceAmount) : roundDown(theroeticalSpaceAmount)
  }

  const practicalQM = practicalSpaceAmount * singleQM

  return {
    theoreticalQM: round(theoreticalQM, 3),
    theroeticalSpaceAmount: round(theroeticalSpaceAmount, 3),
    practicalSpaceAmount: round(practicalSpaceAmount, 3),
    practicalQM: round(practicalQM, 3),
    arbeitsplatzAmount: round(practicalSpaceAmount, 3) * arbeitsplatzAmount,
  }
}

export default getQMAndDeskValues
